import { UIHeading4, UIText1, Image } from '@cian/ui-kit';
import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { IServiceItem } from '../../../containers/OtherServices/utils';
import * as style from './style.css';
import cn from 'clsx';

interface IOtherServicesItemProps extends IServiceItem {
  singleItem?: boolean;
  withoutBorder?: boolean;
  onClick?: () => void;
}

export const OtherServicesItem: React.FC<IOtherServicesItemProps> = ({
  singleItem = false,
  withoutBorder = false,
  onClick,
  title,
  description,
  link,
  icon,
}) => {
  return (
    <a
      className={cn(style['item'], singleItem && style['single-item'], withoutBorder && style['without-border'])}
      href={link}
      onClick={onClick}
      target="_blank"
      rel="noreferrer"
    >
      <div className={style['left']}>
        <div className={style['icon']}>
          <Image src={icon as string} />
        </div>

        <div className={style['title']}>
          <UIHeading4 color="text-primary-default">{title}</UIHeading4>
          <UIText1 color="text-secondary-default">{description}</UIText1>
        </div>
      </div>

      <div>
        <IconActionChevronRight12 />
      </div>
    </a>
  );
};
